import { GetServerSideProps } from 'next'
import Layout from '../components/layouts/Layout'
import { useState } from 'react'
import withoutAuth from '../lib/withoutAuth'
import RequestForm, { RequestData } from '../components/auth/RequestForm'

const forgotPassword = async (email: string): Promise<any> => {
  const response = await fetch('/api/v1/auth/forgot-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })

  const data = await response.json()
  return data
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  return withoutAuth(context)(async () => {
    return {
      props: {},
    }
  })
}

export default function ForgotPassword(): JSX.Element {
  const [requestError, setRequestError] = useState(undefined)
  const [requestSuccess, setRequestSuccess] = useState(undefined)
  const [successDescription, setSuccessDescription] = useState(undefined)

  const forgotPwdFn = async (data: RequestData) => {
    try {
      const result = await forgotPassword(data.email)
      if (!result.error) {
        setRequestSuccess(`Password reset was successfully requested.`)
        setSuccessDescription(
          `Instructions were sent to ${data.email}. Please check your email and click the link to complete your password reset request.`
        )
      } else {
        setRequestError(result.error)
      }
    } catch (error) {
      setRequestError('Request failed. Try again later')
    }
  }

  return (
    <Layout title="Forgot Password">
      <div className="card-container">
        <RequestForm
          title="Reset Password"
          description="Please enter you email address and we well send you instructions to reset your password."
          requestError={requestError}
          requestSuccess={requestSuccess}
          requestSuccessDescription={successDescription}
          onSubmit={forgotPwdFn}
        />
      </div>
    </Layout>
  )
}
